export default __webpack_public_path__ + "static/ImpulsePartners-5e1335bcab4a12e07c6bd070aed8f14b.png";